import React from 'react';

const Wrapper = ({ children, className }) => {
    return (
        <div className={`max-w-screen w-full mx-auto lg:pr-16 pt-2 pb-2 pr-4 pl-4 lg:pl-16 ${className}`}>
            {children}
        </div>
    );
};

export default Wrapper;
